<template>
  <div class="customer-list">
    <div class="customer-list-top">
      <div class="top-l">
        <el-input
          v-model="nickName"
          clearable
          placeholder="客户名称"
        ></el-input>
        <el-button class="top-l-search" @click="searchClick()">查询</el-button>
        <div style="clear: both"></div>
      </div>
      <div style="clear: both"></div>
    </div>
    <div class="customer-list-bottom">
      <div class="customer-list-table">
        <el-table
          :data="yemiandata"
          :header-cell-style="{
            background: '#f3f3f3',
            color: '#323232',
            height: '50px',
          }"
          border
          style="width: 100%"
        >
          <el-table-column prop="jtid" label="集团ID" width="">
          </el-table-column>
          <el-table-column prop="nickname" label="客户名称" width="">
          </el-table-column>
          <el-table-column prop="username" label="登录账号" width="">
          </el-table-column>
          <el-table-column prop="phone_number" label="客户电话" width="">
          </el-table-column>
          <el-table-column prop="email" label="客户邮箱"> </el-table-column>
          <el-table-column prop="balance" label="余额"> </el-table-column>
           <el-table-column prop="balance_voucher" label="抵扣券"> </el-table-column>
          <el-table-column prop="customer_status" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.customer_status == 1">启用</span>
              <span v-else-if="scope.row.customer_status == 2">禁用</span>
            </template>
          </el-table-column>
          <el-table-column prop="created_time" label="创建时间">
          </el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.btnValue"
                placeholder="请选择操作"
                @change="btnClick(scope.row)"
              >
                <el-option
                  v-for="item in btnOptions"
                  :key="item.value"
                  :label="
                    item.label == '禁用'
                      ? scope.row.customer_status == 1
                        ? '禁用'
                        : '启用'
                      : item.label
                  "
                  :value="item.value"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentChange"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
    <!-- 禁用 -->
    <el-dialog
      :visible.sync="prohibitDialog"
      customClass="prohibit-dialog"
      :close-on-click-modal="false"
      width="934px"
      @close="prohibitCancelClick"
    >
      <p class="title">禁用</p>
      <div class="line"></div>
      <div class="prohibit-reason">
        <div class="text"><span class="star">*</span>禁用理由：</div>
        <div class="reason-box">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            clearable
            placeholder="请输入禁用理由"
            v-model="prohibitReason"
          >
          </el-input>
        </div>
      </div>
      <div class="pro-button">
        <el-button class="pro-btn pro-cancel" @click="prohibitCancelClick()"
          >取消</el-button
        >
        <el-button class="pro-btn pro-confirm" @click="prohibitConfirmClick()"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- 车辆 -->
    <el-dialog
      :visible.sync="carDialog"
      customClass="car-dialog"
      width="934px"
      @close="carCancelClick"
    >
      <p class="title">客户车辆信息</p>
      <div class="line"></div>
      <div class="new-car-box clearfix">
        <el-button
          class="new-car-btn addCarPrivilege"
          @click="addCarClick(1)"
          :disabled="addCarPrivilege == 1"
          :class="[addCarPrivilege == 1 ? 'active' : '']"
          >新增</el-button
        >
      </div>
      <div class="car-table">
        <el-table
          :data="carListData"
          :header-cell-style="{
            background: '#f3f3f3',
            color: '#323232',
            height: '50px',
          }"
          border
          style="width: 100%"
        >
          <el-table-column prop="vin" label="VIN" width=""> </el-table-column>
          <el-table-column prop="plate_number" label="车牌号" width="">
            <template slot-scope="scope">{{
              scope.row.plate_number | defaultValFilter
            }}</template>
          </el-table-column>
          <el-table-column prop="created_time" label="添加时间" width="">
          </el-table-column>
          <el-table-column label="操作" width="145">
            <template slot-scope="scope">
              <el-button
                class="edit editCarPrivilege"
                @click="editCarClick(scope.row, 2)"
                :disabled="editCarPrivilege == 1"
                :class="[editCarPrivilege == 1 ? 'active' : '']"
                >编辑</el-button
              >
              <el-button
                class="delete deleteCarPrivilege"
                @click="deleteCarClick(scope.row)"
                :disabled="deleteCarPrivilege == 1"
                :class="[deleteCarPrivilege == 1 ? 'active' : '']"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-pagination
        background
        style="margin-top:10px;"
        layout="prev, pager, next"
        @current-change="changePage"
        :total="carTotal"
      >
      </el-pagination>
    </el-dialog>
    <!-- 用户 -->
    <el-dialog
      :visible.sync="newUserListDialog"
      customClass="car-dialog"
      width="934px"
      @close="carCancelClick"
    >
      <p class="title">用户信息</p>
      <div class="line"></div>
      <div class="new-car-box clearfix">
        <el-button
          class="new-car-btn addUserPrivilege"
          style="width: 70px"
          @click="addUserClick(1)"
          :disabled="addUserPrivilege == 1"
          :class="[addUserPrivilege == 1 ? 'active' : '']"
          >新增用户</el-button
        >
      </div>
      <div class="car-table">
        <el-table
          :data="useList"
          :header-cell-style="{
            background: '#f3f3f3',
            color: '#323232',
            height: '50px',
          }"
          border
          style="width: 100%"
        >
          <el-table-column prop="username" label="用户名" width="">
          </el-table-column>
          <el-table-column prop="phone_number" label="手机号" width="">
            <template slot-scope="scope">{{
              scope.row.phone_number | defaultValFilter
            }}</template>
          </el-table-column>
          <el-table-column prop="created_time" label="添加时间" width="">
          </el-table-column>
          <el-table-column label="操作" width="145">
            <template slot-scope="scope">
              <el-button
                class="edit editUserPrivilege"
                @click="editUserClick(scope.row, 2)"
                :disabled="editUserPrivilege == 1"
                :class="[editUserPrivilege == 1 ? 'active' : '']"
                >编辑</el-button
              >
              <el-button
                class="delete deleteUserPrivilege"
                @click="deleteUserClick(scope.row)"
                :disabled="deleteUserPrivilege == 1"
                :class="[deleteUserPrivilege == 1 ? 'active' : '']"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 充值 -->
    <el-dialog
      :visible.sync="rechargeDialog"
      customClass="recharge-dialog"
      :close-on-click-modal="false"
      width="934px"
      @close="rechargeCancelClick"
    >
      <p class="title">充值</p>
      <div class="line"></div>
      <div class="recharge">
        <div class="text"><span class="star"></span>充值金额：</div>
        <el-input
          v-model="recharge"
          clearable
          :placeholder="placehold"
        ></el-input>
      </div>
      <div class="recharge" style="margin-top:10px;">
        <div class="text" style="margin-left:14px;"><span class="star"></span>抵扣券：</div>
        <el-input
          v-model="discount"
          clearable
          :placeholder="placeDiscount"
        ></el-input>
      </div>
      <div class="recharge" style="margin-top:10px;">
        <div class="text"><span class="star"></span>最低余额：</div>
        <el-input
          v-model="freeze_money_lower"
          clearable
          :placeholder="lowMoney"
        ></el-input>
      </div>
      <div class="recharge" style="margin-top:10px;">
        <div class="text"><span class="star"></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;备注：</div>
        <el-input
          type="textarea"
          :rows="2"
          maxlength="50"
          placeholder="请输入备注，不超过50字"
          v-model="textarea">
        </el-input>
      </div>
      <div class="pro-button">
        <el-button class="pro-btn pro-cancel" @click="rechargeCancelClick()"
          >取消</el-button
        >
        <el-button class="pro-btn pro-confirm" @click="rechargeConfirmClick()"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- 签约场站 -->
    <el-dialog
      title
      :visible.sync="signingStationDialog"
      @close="stationCancelClick"
      :close-on-click-modal="false"
      customClass="signing-station-dialog"
      width="934px"
    >
      <p class="title">签约场站</p>
      <div class="line"></div>
      <div class="station-authorization">
        <div class="s-a-top">
          <div class="content">
            <!-- <span class="type" v-if="length>0">用电量：</span> -->
            <div class="content-box"  v-for="(item, index) in current_signed1"  :key="index">
              <span class="text">{{ item.station_name }}</span>
              <div class="triangle_border_nw"></div>
              <span
                class="fork"
                @click="deleteStationClick(item.station_name, item.station_id)"
                >×</span
              >
              <div style="clear: both"></div>
            </div>
            <div style="clear: both"></div>
          </div>
        </div>
        <div class="s-a-center">
          <span class="name">场站</span>
          <el-select
            v-model="provincesName"
            clearable
            placeholder="请选择省份"
            @change="provinceChange"
          >
            <el-option
              v-for="item in provincesList"
              :key="item.province"
              :label="item.province"
              :value="item.province"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="cityName"
            clearable
            placeholder="请选择城市"
            @change="getStation"
          >
            <el-option
              v-for="item in cityList"
              :key="item.city"
              :label="item.city"
              :value="item.city"
            >
            </el-option>
          </el-select>
          <span class="name settlement">结算模式</span>
          <el-select
            v-model="settlementType"
            clearable
            placeholder="请选择结算模式"
            @change="settlementChange"
          >
            <el-option
              v-for="item in settlementList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div style="clear: both"></div>
        </div>
        <div class="s-a-bottom">
          <div class="content">
            <el-checkbox-group v-model="checkList">
              <el-checkbox
                v-for="(item, index) in stationList"
                :key="index"
                :label="item.station_name"
                :disabled="item.disabled"
                @change="
                  (val) => {
                    checkboxChange(val, item.station_id, item.station_name);
                  }
                "
              ></el-checkbox>
            </el-checkbox-group>
            <div style="clear: both"></div>
          </div>
        </div>
        <div class="pro-button">
          <el-button class="pro-btn pro-cancel" @click="stationCancelClick()"
            >取消</el-button
          >
          <el-button class="pro-btn pro-confirm" @click="stationConfirmClick()"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 费率 -->
    <el-dialog
      title
      :visible.sync="rateDialog"
      @close="rateCancelClick"
      customClass="rate-dialog"
      :close-on-click-modal="false"
      width="40%"
    >
      <p class="title">费率</p>
      <div class="line"></div>
      <div class="rate-content">
        <el-row>
          <el-col :span="10">
            <span class="star" style="margin-left: 11px"></span>
            <span class="text">服务费折扣：</span>
          </el-col>
          <el-col :span="6">
            <el-input
              v-model="service_charge"
              clearable
              placeholder="请输入服务费折扣"
            ></el-input>
          </el-col>
          <el-col :span="8">&nbsp;%</el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <span class="star" style="margin-left: 11px"></span>
            <span class="text">电费折扣：</span>
          </el-col>
          <el-col :span="6">
            <el-input
              v-model="electric_charge"
              clearable
              placeholder="请输入电费折扣"
            ></el-input>
          </el-col>
          <el-col :span="8">&nbsp;%</el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <span>&nbsp;&nbsp;&nbsp;&nbsp;*</span>
            <span>催缴：</span>
          </el-col>
          <el-col :span="6">
            <el-select v-model="call" placeholder="请选择">
              <el-option
                v-for="item in callList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <div class="parameter-btn">
          <el-button class="cancel" @click="rateCancelClick()">取消</el-button>
          <el-button class="confirm" @click="rateConfirmClick()"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 新增用户 -->
    <el-dialog
      title
      :visible.sync="newUserDialog"
      @close="newUserCancelClick"
      :close-on-click-modal="false"
      customClass="rate-dialog"
      width="934px"
    >
      <p class="title">{{ useTitle }}用户</p>
      <div class="line"></div>
      <div class="rate-content">
        <el-row>
          <el-col :span="9">
            <span>*</span>
            <span>用户名：</span>
          </el-col>
          <el-col :span="8">
            <el-input
              v-model="newUserName"
              clearable
              placeholder="请输入用户名"
            ></el-input>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="9">
            <span>*</span>
            <span>手机号：</span>
          </el-col>
          <el-col :span="8">
            <el-input
              v-model="newUserPhone"
              clearable
              placeholder="请输入手机号"
            ></el-input>
          </el-col>
        </el-row>

        <div class="parameter-btn">
          <el-button class="cancel" @click="newUserCancelClick()"
            >取消</el-button
          >
          <el-button class="confirm" @click="newUserConfirmClick()"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 新增车辆信息 -->
    <el-dialog
      title
      :visible.sync="newCarMessageDialog"
      @close="newCarMessageCancelClick"
      customClass="rate-dialog"
      :close-on-click-modal="false"
      width="700px"
    >
      <p class="title">{{ carTitle }}车辆信息</p>
      <div class="line"></div>
      <div class="rate-content">
        <el-row>
          <el-col :span="9">
            <span class="star">*</span>
          <span class="text">VIN码：</span>
          </el-col>
          <el-col :span="10">
             <el-input
            v-model="newCarVIN"
            clearable
            placeholder="请输入VIN码"
          ></el-input>
          </el-col>
        </el-row>
         <el-row>
          <el-col :span="9">
            <span class="star">*</span>
          <span class="text">车牌号：</span>
          </el-col>
          <el-col :span="10">
           <el-input
            v-model="newCarNumber"
            clearable
            placeholder="请输入车牌号"
          ></el-input>
          </el-col>
        </el-row>
        
       
        <div class="parameter-btn">
          <el-button class="cancel" @click="newCarMessageCancelClick()"
            >取消</el-button
          >
          <el-button class="confirm" @click="newCarMessageConfirmClick()"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 冻结 -->
    <el-dialog
      title
      :visible.sync="frozenDialog"
      @close="frozenCancelClick"
      :close-on-click-modal="false"
      customClass="frozen-dialog"
      width="934px"
    >
      <p class="title">冻结</p>
      <div class="line"></div>
      <div class="rate-content">
        <div class="row-details">
          <span class="star"></span>
          <span class="text">当前每辆车冻结额度：</span>
          <el-input
            v-model="nowMoney"
            clearable
            placeholder="显示当前冻结金额"
            disabled
          ></el-input>
        </div>
        <div class="row-details">
          <span class="star" style="margin-left: -11px">*</span>
          <span class="text">修改每辆车冻结额度：</span>
          <el-input
            v-model="money"
            clearable
            placeholder="请输入冻结金额"
          ></el-input>
        </div>
        <div class="parameter-btn">
          <el-button class="cancel" @click="frozenCancelClick()"
            >取消</el-button
          >
          <el-button class="confirm" @click="frozenConfirmClick()"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      placeDiscount:0,
      discount:"",
      lowMoney:0,
      freeze_money_lower:"",
      carTotal: 0,
      electric_charge: "",
      placehold: "",
      prohibitDialog: false,
      carDialog: false,
      rechargeDialog: false,
      signingStationDialog: false,
      rateDialog: false,
      newUserDialog: false,
      newUserListDialog: false,
      newCarMessageDialog: false,
      frozenDialog: false,
      carTitle: "新增",
      useTitle: "新增",
      tableData: [],
      // 页面需要展现的数据
      yemiandata: [],
      // 页面展现条数
      datanum: 10,
      // 开始页数
      startnum: 0,
      // 结束页数
      endnum: 1,
      // 一共多少页
      totalNum: 0,
      input: "",
      nickName: "",
      prohibitReason: "",
      prohibitId: "",
      carList: [],
      carListData:[],
      recharge: "",
      rechargeId: "",
      provincesName: "",
      provincesList: [],
      cityName: "",
      cityList: [],
      stationList: [],
      checkList: [],
      settlementList: [
        {
          value: "2",
          label: "充电量结算方式",
        },
        {
          value: "1",
          label: "用电量",
        },
      ],
      settlementType: "2",
      customerStations: {},
      length: 0,
      stations: "",
      signingStationId: "",
      current_signed1: [],
      current_signed2: [],
      service_charge: "",
      call: "1",
      callList: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      rateId: "",
      newUserName: "",
      newUserPhone: "",
      newCarVIN: "",
      newCarNumber: "",
      btnOptions: [
        {
          value: "冻结",
          label: "冻结",
          disabled: true,
        },
        {
          value: "车辆",
          label: "车辆",
          disabled: true,
        },
        {
          value: "用户",
          label: "用户",
          disabled: true,
        },
        {
          value: "启用/禁用客户",
          label: "禁用",
          disabled: true,
        },
        {
          value: "充值",
          label: "充值",
          disabled: true,
        },
        {
          value: "场站",
          label: "场站",
          disabled: true,
        },
        {
          value: "费率",
          label: "费率",
          disabled: true,
        },
      ],
      addCarPrivilege: 1, //新增车辆
      editCarPrivilege: 1, //编辑车辆
      deleteCarPrivilege: 1, //删除车辆
      addUserPrivilege: 1, //新增用户
      editUserPrivilege: 1, //编辑用户
      deleteUserPrivilege: 1, //删除用户
      rechargePrivilege: 1, //充值
      stationPrivilege: 1, //车辆
      ratePrivilege: 1, //费率
      btnValue: "",
      customer_id: "",
      vinId: "",
      vinNumber: "",
      newUserNumber: "",
      useList: [],
      useId: "",
      money: "",
      frozenId: "",
      nowMoney: "",
      textarea:"",//充值-->备注
    };
  },
  mounted() {
    this.$nextTick(function () {
      let role = [];
      role = this.$store.state.role;
      for (let i in role) {
        if (role[i].view_name == "会员管理") {
          for (let j in role[i].chlid) {
            if (role[i].chlid[j].view_name == "集团客户") {
              for (let m in role[i].chlid[j].method) {
                for (let o in this.btnOptions) {
                  if (
                    role[i].chlid[j].method[m].method_name ==
                    this.btnOptions[o].value
                  ) {
                    this.btnOptions[o].disabled = false;
                  }
                }
              }
              for (let m in role[i].chlid[j].method) {
                if (role[i].chlid[j].method[m].method_name == "新增用户") {
                  this.addUserPrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "编辑用户"
                ) {
                  this.editUserPrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "删除用户"
                ) {
                  this.deleteUserPrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "新增车辆"
                ) {
                  this.addCarPrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "编辑车辆"
                ) {
                  this.editCarPrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "删除车辆"
                ) {
                  this.deleteCarPrivilege = 0;
                }
              }
            }
          }
        }
      }

      this.getDataList();
    });
  },
  methods: {
   
    currentChange(data) {
      this.endnum = data;
      this.startnum = data - 1;
      // this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      if (this.totalNum > 10) {
        this.yemiandata = this.tableData.slice(
          this.startnum * this.datanum,
          this.endnum * this.datanum
        );
      } else {
        this.yemiandata = this.tableData;
      }
    },
    getDataList(nickName) {
      if (nickName == undefined) {
        nickName = "";
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getCustomers",
        nickname: nickName,
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.tableData = su.data.list;
            this.totalNum = this.tableData.length;
            if (this.totalNum > 10) {
              // debugger
              this.yemiandata = this.tableData.slice(
                this.startnum * this.datanum,
                this.endnum * this.datanum
              );
            } else {
              this.yemiandata = this.tableData;
            }
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    searchClick() {
      this.startnum = 0;
      this.endnum = 1;
      this.totalNum = 0;
      this.getDataList(this.nickName);
    },
    blacklistBtn(row) {
      this.prohibitDialog = true;
      this.prohibitReason = "";
      this.prohibitId = row.id;
    },
    prohibitCancelClick() {
      this.prohibitDialog = false;
      this.prohibitReason = "";
      this.prohibitId = "";
      for (let i in this.tableData) {
        this.tableData[i].btnValue = "";
      }
    },
    prohibitConfirmClick() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "disableCustomer",
        id: this.prohibitId,
        disabled_reason: this.prohibitReason,
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.$message.success(su.data.message);
            this.prohibitDialog = false;
            this.getDataList();
            this.prohibitReason = "";
            this.prohibitId = "";
            for (let i in this.tableData) {
              this.tableData[i].btnValue = "";
            }
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    carCancelClick() {
      this.carDialog = false;
      this.carList = [];
      this.carListData = [];
      for (let i in this.tableData) {
        this.tableData[i].btnValue = "";
      }
    },
    carClick(id) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getVins",
        id: id,
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.carDialog = true;
            this.carList = su.data.list;
            this.carListData = this.carList.slice(0,10);
            this.carTotal = su.data.list.length;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    changePage(page) {
      console.log(page);
      this.carListData = this.carList.slice((page-1)*10,page*10);
    },
    feeClick(row) {
      this.placeDiscount="抵扣："+row.balance_voucher+"元"
      this.rechargeId = row.id;
      this.recharge = "";
      this.placehold = "余额：" + row.balance + "元";
      this.lowMoney= "最低余额：" + row.freeze_money_lower + "元";
      this.textarea = row.remarks;
      this.rechargeDialog = true;
    },
    rechargeCancelClick() {
      this.rechargeDialog = false;
      this.rechargeId = "";
      this.recharge = "";
      this.freeze_money_lower="";
      this.discount="";
      this.textarea = "";
      for (let i in this.tableData) {
        this.tableData[i].btnValue = "";
      }
    },
    rechargeConfirmClick() {
      if(this.freeze_money_lower<0){
        this.$message.warning("最低余额不能小于0")
        return
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "rechargeBalance",
        id: this.rechargeId,
        fee: this.recharge,
        freeze_money_lower:this.freeze_money_lower,
        balance_voucher:this.discount,
        remarks:this.textarea,
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.$message.success(su.data.message);
            this.rechargeDialog = false;
            this.rechargeId = "";
            this.recharge = "";
            this.getDataList();
            for (let i in this.tableData) {
              this.tableData[i].btnValue = "";
            }
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getProvince() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.provincesList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    provinceChange(province) {
      this.cityName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province: province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.cityList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getStation(city) {
      this.stationName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city: city,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.stationList = su.data.list;

            for (let i in this.stationList) {
              for (let j in this.customerStations.other_signed) {
                // if(this.stationList[i].station_id == this.customerStations.other_signed[j].station_id){
                //   this.stationList[i].disabled = true;
                // }
              }
              for (let j in this.current_signed1) {
                if (
                  this.stationList[i].station_id ==
                  this.current_signed1[j].station_id
                ) {
                  this.checkList.push(this.current_signed1[j].station_name);
                }
              }
            }

            // for(let i in this.stationList){
            //   for(let j in this.customerStations.current_signed){
            //     if(this.stationList[i].station_id == this.customerStations.current_signed[j].station_id){
            //       this.checkList.push(this.customerStations.current_signed[j].station_name);
            //     }
            //   }
            // }
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    signingStation(row) {
      this.signingStationId = row.id;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getCustomerStations",
        id: row.id,
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.customerStations = su.data.list;
            this.signingStationDialog = true;
            this.getProvince();
            for (let i in su.data.list.current_signed) {
              // if(su.data.list.current_signed[i].pay_type == "1"){
              //   this.current_signed1.push(su.data.list.current_signed[i]);
              // } else {
              //   this.current_signed2.push(su.data.list.current_signed[i]);
              // }
              this.current_signed1.push(su.data.list.current_signed[i]);
            }
            this.length = this.current_signed1.length;
            // console.log(this.current_signed1);
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    settlementChange() {},
    enableBtn(row) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "enableCustomer",
        id: row.id,
      };
      this.$confirm("确定启用", "启用", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "",
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/Customer/index",
            data: params,
            transformRequest: [
              (data) => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              },
            ],
          })
            .then((su) => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.getDataList();
              } else if (su.data.code == 300) {
                localStorage.clear();
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900) {
              } else {
                this.$message.error(su.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    checkboxChange(val, stationId, name) {
      // console.log(val);
      // console.log(stationId);
      // console.log(name);
      if (val == true) {
        this.current_signed1.push({
          pay_type: this.settlementType,
          station_id: stationId,
          station_name: name,
        });
      } else if (val == false) {
        for (let i in this.current_signed1) {
          if (this.current_signed1[i].station_id == stationId) {
            this.current_signed1.splice(i, 1);
          }
        }
      }
    },
    stationCancelClick() {
      this.signingStationDialog = false;
      this.checkList = [];
      this.customerStations = {};
      this.length = 0;
      this.signingStationId = "";
      this.stationList = [];
      this.cityName = "";
      this.cityList = [];
      this.provincesName = "";
      this.current_signed1 = [];
      for (let i in this.tableData) {
        this.tableData[i].btnValue = "";
      }
    },
    stationConfirmClick() {
      let stations = "";
      for (let i in this.current_signed1) {
        stations +=
          "" +
          this.current_signed1[i].station_id +
          "," +
          this.current_signed1[i].pay_type +
          ";";
      }
      stations = stations.substr(0, stations.length - 1);
      // console.log(stations);
      // return
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "signStations",
        id: this.signingStationId,
        stations: stations,
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.signingStationDialog = false;
            this.$message.success(su.data.message);
            this.getDataList();
            this.checkList = [];
            this.customerStations = {};
            this.current_signed1 = [];
            this.length = 0;
            this.signingStationId = "";
            this.stationList = [];
            this.cityName = "";
            this.cityList = [];
            this.provincesName = "";
            for (let i in this.tableData) {
              this.tableData[i].btnValue = "";
            }
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    deleteStationClick(name, id) {
      // console.log(name);
      // console.log(id);
      for (let i in this.current_signed1) {
        if (this.current_signed1[i].station_id == id) {
          this.current_signed1.splice(i, 1);
        }
      }
      for (let j in this.checkList) {
        if (this.checkList[j] == name) {
          this.checkList.splice(j, 1);
        }
      }
      // console.log(this.customerStations.current_signed);
      // return
    },
    rateClick(row) {
      this.rateId = row.id;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getCustomerSets",
        id: row.id,
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.rateDialog = true;
            this.call = su.data.list.is_urge_payment;
            this.service_charge = su.data.list.serv_discount;
            this.electric_charge = su.data.list.ele_discount;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    rateCancelClick() {
      this.rateDialog = false;
      this.service_charge = "";
      this.call = "1";
      this.rateId = "";
      for (let i in this.tableData) {
        this.tableData[i].btnValue = "";
      }
    },
    // 判断是否是小数
    numbera(x) {
      var y = String(x).indexOf(".") + 1; //获取小数点的位置
      var count = String(x).length - y; //获取小数点后的个数
      return y; //y大于0为小数
    },
    rateConfirmClick() {
      if (this.service_charge > 100 || this.electric_charge > 100) {
        this.$message.warning("折扣不能超过100");
        return;
      }

      if (
        this.numbera(this.service_charge) > 0 ||
        this.numbera(this.electric_charge) > 0
      ) {
        this.$message.warning("折扣不能为小数");
        return;
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "saveCustomerSets",
        id: this.rateId,
        serv_discount: this.service_charge,
        ele_discount: this.electric_charge,
        is_urge_payment: this.call,
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.rateDialog = false;
            this.service_charge = "";
            this.electric_charge = "";
            this.call = "1";
            this.rateId = "";
            for (let i in this.tableData) {
              this.tableData[i].btnValue = "";
            }
            this.$message.success(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    newUserConfirmClick() {
      if (isEmpty(this.newUserName)) {
        this.$message.warning("用户名不能为空！");
        return;
      } else if (isEmpty(this.newUserPhone)) {
        this.$message.warning("手机号不能为空！");
        return;
      } else if (!isPhoneNumber(this.newUserPhone)) {
        this.$message.warning("请填写正确手机号码格式！");
        return;
      }
      let params = {};
      if (this.newUserNumber == 1) {
        params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action: "addVinUser",
          applet_id: this.customer_id,
          username: this.newUserName,
          phone_number: this.newUserPhone,
        };
      } else if (this.newUserNumber == 2) {
        params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action: "saveVinUser",
          applet_id: this.customer_id,
          username: this.newUserName,
          phone_number: this.newUserPhone,
          id: this.useId,
        };
      }

      this.$api({
        method: "post",
        url: "/api.php/VinUser/Index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.newUserDialog = false;
            this.getUserClick(this.customer_id);
            for (let i in this.tableData) {
              this.tableData[i].btnValue = "";
            }
            this.$message.success(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    newUserCancelClick() {
      this.newUserDialog = false;
      this.newUserName = "";
      this.newUserPhone = "";
      for (let i in this.tableData) {
        this.tableData[i].btnValue = "";
      }
    },
    newCarMessageCancelClick() {
      this.newCarMessageDialog = false;
      this.newCarVIN = "";
      this.newCarNumber = "";
      for (let i in this.tableData) {
        this.tableData[i].btnValue = "";
      }
    },
    newCarMessageConfirmClick() {
      if (isEmpty(this.newCarVIN)) {
        this.$message.warning("VIN不能为空！");
        return;
      } else if (isEmpty(this.newCarNumber)) {
        this.$message.warning("车牌号不能为空！");
        return;
      } else if (!isPlateNumber(this.newCarNumber)) {
        this.$message.warning("请填写正确格式车牌号");
        return;
      }

      let params = {};

      if (this.vinNumber == 1) {
        params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action: "addCar",
          customer_id: this.customer_id,
          vin: this.newCarVIN,
          plate_number: this.newCarNumber,
        };
      } else if (this.vinNumber == 2) {
        params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action: "saveCar",
          customer_id: this.customer_id,
          vin: this.newCarVIN,
          plate_number: this.newCarNumber,
          id: this.vinId,
        };
      }

      this.$api({
        method: "post",
        url: "/api.php/Car/Index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.newCarMessageDialog = false;
            this.carClick(this.customer_id);
            for (let i in this.tableData) {
              this.tableData[i].btnValue = "";
            }
            this.$message.success(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    addCarClick(num) {
      this.newCarMessageDialog = true;
      this.vinNumber = num;
    },
    editCarClick(row, num) {
      this.newCarMessageDialog = true;
      this.carTitle = "编辑";
      this.vinId = row.id;
      this.newCarVIN = row.vin;
      this.newCarNumber = row.plate_number;
      this.vinNumber = num;
    },
    deleteCarClick(row) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "deleteCar",
        id: row.id,
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "",
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/Car/Index",
            data: params,
            transformRequest: [
              (data) => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              },
            ],
          })
            .then((su) => {
              if (su.data.code == 1) {
                this.carClick(this.customer_id);
                this.$message.success(su.data.message);
              } else if (su.data.code == 300) {
                localStorage.clear();
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900) {
              } else {
                this.$message.error(su.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    btnClick(row) {
      // console.log(row.btnValue);
      this.customer_id = row.id;
      if (row.btnValue == "车辆") {
        this.carClick(row.id);
      } else if (row.btnValue == "冻结") {
        this.frozenClick(this.customer_id, row.freeze_money_needed);
      } else if (row.btnValue == "用户") {
        this.getUserClick(this.customer_id);
      } else if (row.btnValue == "充值") {
        this.feeClick(row);
      } else if (row.btnValue == "场站") {
        this.signingStation(row);
      } else if (row.btnValue == "费率") {
        this.rateClick(row);
      } else if (row.customer_status == 1) {
        this.blacklistBtn(row);
      } else if (row.customer_status == 2) {
        this.enableBtn(row);
      }
    },
    addUserClick(num) {
      this.newUserNumber = num;
      this.newUserDialog = true;
      this.useTitle = "新增";
    },
    editUserClick(row, num) {
      this.newUserNumber = num;
      this.newUserDialog = true;
      this.useTitle = "编辑";
      this.newUserName = row.username;
      this.newUserPhone = row.phone_number;
      this.useId = row.id;
    },
    deleteUserClick(row) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "deleteVinUser",
        id: row.id,
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "",
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/VinUser/Index",
            data: params,
            transformRequest: [
              (data) => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              },
            ],
          })
            .then((su) => {
              if (su.data.code == 1) {
                this.getUserClick(this.customer_id);
                this.$message.success(su.data.message);
              } else if (su.data.code == 300) {
                localStorage.clear();
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900) {
              } else {
                this.$message.error(su.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    getUserClick(id) {
      // debugger
      this.newUserListDialog = true;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getVinUsers",
        applet_id: this.customer_id,
        page_size: 10,
      };
      this.$api({
        method: "post",
        url: "/api.php/VinUser/Index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.useList = su.data.data;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else if (su.data.code == 303) {
          } else {
            // this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    frozenClick(id, data) {
      this.frozenDialog = true;
      this.frozenId = id;
      this.nowMoney = data;
    },
    frozenCancelClick() {
      this.frozenDialog = false;
      this.money = "";
      this.frozenId = "";
      this.nowMoney = "";
      for (let i in this.tableData) {
        this.tableData[i].btnValue = "";
      }
    },
    frozenConfirmClick() {
      let reg = /^[0-9]*$/;

      if (isEmpty(this.money)) {
        this.$message.warning("冻结金额不能为空");
        return;
      } else if (this.money > 9999.99) {
        this.$message.warning("冻结金额不能大于9999.99");
        return;
      } else if (!reg.test(this.money)) {
        this.$message.warning("冻结金额只能输入数字");
        return;
      } 
      

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "freeze_money",
        group_id: this.frozenId,
        freeze_money_needed: this.money,
      };
      this.$api({
        method: "post",
        url: "/api.php/user/freeze_money",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.frozenDialog = false;
            this.getDataList();
            this.money = "";
            this.frozenId = "";
            this.nowMoney = "";
            for (let i in this.tableData) {
              this.tableData[i].btnValue = "";
            }
            this.$message.success(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
            this.$message.warning(su.data.message);
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped lang="scss">
.customer-list {
  padding: 20px 0;
  .customer-list-top {
    .top-l {
      //   display: flex;
      float: left;
      width: 80%;
      margin-left: 1%;
      .el-input {
        width: 20%;
        float: left;
      }
      .top-l-search {
        background-color: #0071bd;
        border: none;
        color: #fefffd;
        margin-left: 16px;
        float: left;
      }
      .top-l-search:active {
        background-color: #409eff;
      }
    }
    .top-r {
      width: 30%;
      float: right;
      margin-right: 1%;
      .el-button {
        background-color: #f15500;
        border: none;
        color: #fefffd;
        float: right;
      }
    }
  }
  .customer-list-bottom {
    .customer-list-table {
      width: 98%;
      margin-left: 1%;
      margin-top: 26px;
      margin-bottom: 10px;
      .table-btn {
        width: 54px;
        height: 26px;
        padding: 0;
        background-color: #006fbe;
        border: none;
        color: #fefffd;
        margin-left: 5px;
        font-size: 12px;
      }
      .table-vehicle {
        background-color: #00b270;
      }
      .table-vehicle.active {
        background-color: #a5a5a5;
      }
      .table-dis {
        background-color: #eb0000;
      }
      .table-dis.active {
        background-color: #a5a5a5;
      }
      .table-recharge {
        background-color: #ec6900;
      }
      .table-recharge.active {
        background-color: #a5a5a5;
      }
      .table-s-s {
        width: 80px;
      }
      .table-s-s.active {
        background-color: #a5a5a5;
      }
      .table-rate {
        background-color: #29aeb5;
      }
      .table-rate.active {
        background-color: #a5a5a5;
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 24px;
      margin-top: 20px;
      margin-right: 18px;
    }
  }
  .prohibit-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .prohibit-reason {
      width: 90%;
      // margin-left: 4%;
      .text {
        display: inline-block;
        width: 26%;
        text-align: right;
        vertical-align: top;
        .star {
          color: #ee0002;
          margin-right: 6px;
        }
      }
      .reason-box {
        display: inline-block;
        width: 70%;
      }
    }
    .pro-button {
      margin-top: 40px;
      .pro-cancel {
        width: 16%;
        height: 50px;
        background-color: #0071bd;
        border: none;
        color: #ffffff;
      }
      .pro-confirm {
        width: 16%;
        height: 50px;
        background-color: #02b36f;
        border: none;
        color: #ffffff;
      }
    }
  }
  .car-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .new-car-box {
      margin-bottom: 20px;
      .new-car-btn {
        float: right;
        background-color: #ec6900;
        margin-right: 10px;
      }
      .addCarPrivilege.active {
        background-color: #a5a5a5;
      }
      .addUserPrivilege.active {
        background-color: #a5a5a5;
      }
    }
    .car-table {
      width: 98%;
      margin-left: 1%;
      .editCarPrivilege.active {
        background-color: #a5a5a5;
      }
      .deleteCarPrivilege.active {
        background-color: #a5a5a5;
      }
      .editUserPrivilege.active {
        background-color: #a5a5a5;
      }
      .deleteUserPrivilege.active {
        background-color: #a5a5a5;
      }
    }
    .el-button {
      background-color: #0171bd;
      border: none;
      color: #fefffd;
      width: 54px;
      height: 26px;
      padding: 0;
    }
    .delete {
      background-color: #02b271;
    }
  }
  .recharge-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .recharge {
      .text {
        display: inline-block;
        .star {
          color: #ee0002;
          margin-right: 6px;
        }
      }
      .el-input {
        width: 40%;
      }
      .el-textarea {
        width: 40%;
      }
    }
    .pro-button {
      margin-top: 40px;
      .pro-cancel {
        width: 16%;
        height: 40px;
        background-color: #0071bd;
        border: none;
        color: #ffffff;
      }
      .pro-confirm {
        width: 16%;
        height: 40px;
        background-color: #02b36f;
        border: none;
        color: #ffffff;
      }
    }
  }
  .signing-station-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .station-authorization {
      .s-a-top {
        width: 96%;
        min-height: 170px;
        margin-left: 2%;
        border: 1px solid #dedede;
        border-radius: 4px;
        .content {
          margin-left: 8px;
          margin-top: 10px;
          .type {
            float: left;
            line-height: 38px;
            color: #333333;
            font-weight: 550;
          }
          .content-box {
            display: inline-block;
            min-width: 90px;
            height: 36px;
            border: 1px solid #d3d3d3;
            position: relative;
            float: left;
            margin-left: 10px;
            padding-left: 10px;
            .text {
              text-align: center;
              line-height: 36px;
              color: #555555;
            }
            .triangle_border_nw {
              width: 0;
              height: 0;
              // border-width:30px 30px 0 0;
              border-width: 0 15px 15px 0;
              border-style: solid;
              border-color: transparent #d3d3d3 transparent transparent;
              // margin: auto 40px;
              position: relative;
              float: right;
            }
            .fork {
              color: #555555;
              font-size: 5px;
              position: absolute;
              right: 0;
              top: -2px;
              cursor: pointer;
            }
          }
        }
      }
      .s-a-center {
        margin-top: 18px;
        margin-bottom: 18px;
        width: 96%;
        margin-left: 2%;
        .name {
          float: left;
          line-height: 40px;
          margin-right: 20px;
          color: #333333;
          font-weight: 600;
        }
        .el-select {
          width: 20%;
          float: left;
          margin-right: 12px;
        }
        .settlement {
          margin-left: 4%;
        }
      }
      .s-a-bottom {
        width: 96%;
        min-height: 170px;
        margin-left: 2%;
        border: 1px solid #dedede;
        border-radius: 4px;
        .content {
          margin-left: 18px;
          margin-top: 20px;
          // .el-checkbox-group {
          //   float: left;
          // }
          .el-checkbox {
            float: left;
            margin-bottom: 10px;
          }
        }
      }
      .pro-button {
        margin-top: 40px;
        .pro-cancel {
          width: 16%;
          height: 50px;
          background-color: #0071bd;
          border: none;
          color: #ffffff;
        }
        .pro-confirm {
          width: 16%;
          height: 50px;
          background-color: #02b36f;
          border: none;
          color: #ffffff;
        }
      }
    }
  }
  .rate-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .rate-content {
      .el-row {
        margin-bottom: 20px;
        .el-col {
          line-height: 40px;
          span:first-child {
            color: red;
          }
        }
        .el-col:first-child {
          text-align: right;
        }
        .el-col:last-child {
          text-align: left;
        }
      }
      .parameter-btn {
        margin-top: 40px;
        .cancel {
          width: 20%;
          background-color: #0071bd;
          color: #ffffff;
          border: none;
          height: 50px;
        }
        .confirm {
          width: 20%;
          background-color: #02b36f;
          color: #ffffff;
          border: none;
          height: 50px;
        }
      }
    }
  }
  .frozen-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .rate-content {
      .row-details {
        margin-bottom: 16px;
        .star {
          color: #ec0000;
        }
        .el-input,
        .el-select {
          width: 33%;
        }
      }
      .parameter-btn {
        margin-top: 40px;
        .cancel {
          width: 20%;
          background-color: #0071bd;
          color: #ffffff;
          border: none;
          height: 50px;
        }
        .confirm {
          width: 20%;
          background-color: #02b36f;
          color: #ffffff;
          border: none;
          height: 50px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.customer-list
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td
  .table-s-s {
  background-color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/components/membershipManagement/customerList.vue